import { t, tf } from "../i18n.js";
// ============================================================
// Einstiegspunkt für stats.html — "Meine Statistiken"
//
// Umbau 07.08.2026 (Aufgabe 3): Die Seite zeigt ausschließlich die
// EIGENEN Statistiken, detailliert je Spielmodus. Sie verwendet die
// Reiter- und Kennzahlen-Engine aus profile.js UNVERÄNDERT (profileView
// bleibt null = eigene Ansicht; die Abfragen filtern über currentUser.id).
// Fremde Spieler laufen über das Freunde-Stats-Modal in der App
// (friends.js), nicht mehr über diese Seite.
//
// Login-Zustand: Die Supabase-Session liegt im localStorage und überlebt
// den Seitenwechsel — hier wird sie nur gelesen.
// ============================================================

// style.css kommt über das <link>-Tag der Seite.

// --- Bibliotheken (Legacy-Code erwartet sie auf window) ---
import Chart from "chart.js/auto";
window.Chart = Chart;

// --- Supabase-Client (setzt window._supabase) ---
import "./supabase-client.js";

// --- Globale Variablen, die profile.js aus der Shell kennt. ES-Module
//     laufen im Strict Mode: Zuweisungen wie "currentUser = ..." brauchen
//     die window-Eigenschaft vorab. ---
window.currentUser = null;
window.isGuest = true;
window.myOnlineName = "";

// --- Shims für die Screen-Steuerung: profile.js erwartet sie aus app.js.
//     Auf dieser Seite gibt es nur die eine Ansicht - Minimalfassungen. ---
function hideAllScreens() {}
function showScreenElement(el) {
  if (el) el.style.display = "block";
}
function goHome() {}
Object.assign(window, { hideAllScreens, showScreenElement, goHome });

// --- Anwendungscode (unverändert) ---
import "../ui-kit.js";
// dartboard.js vor heatmap.js: liefert createDartboard/scoreAt als
// Untergrund und Wertung der Heatmap (KONZEPT_HEATMAP.md P2).
import "../dartboard.js";
import "../heatmap.js";
import "../stats501-erweitert.js";
import "../profile.js";

// --- Initialisierung ---
window.addEventListener("DOMContentLoaded", async () => {
  const guestHint = document.getElementById("stats-guest-hint");
  const content = document.getElementById("stats-content");

  try {
    const {
      data: { session },
    } = await window._supabase.auth.getSession();
    if (session) {
      window.currentUser = session.user;
      window.isGuest = false;
      window.myOnlineName =
        session.user.user_metadata?.display_name ||
        session.user.user_metadata?.full_name ||
        session.user.email.split("@")[0];
    }
  } catch (error) {
    console.error(t("js.einstseite.001"), error);
  }

  if (window.isGuest) {
    if (guestHint) guestHint.style.display = "block";
    return;
  }

  if (content) content.style.display = "block";

  // Reiter-Engine aus profile.js: Reiter bauen, 501 als Startreiter,
  // Gesamtzahlen parallel laden.
  if (typeof window.renderProfileTabs === "function") window.renderProfileTabs();
  if (typeof window.switchProfileTab === "function")
    window.switchProfileTab("501");
  if (typeof window.loadProfileTotals === "function")
    window.loadProfileTotals();
});
